
import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '@/components/common/organisms/PaginationButton.vue'

export type StudyData = {
  studyName: string
  grades: [
    {
      value: number
      text: string
    }
  ]
  isScoring: boolean
}

export type StudentForStudyData = {
  bcbtCode: string
  branchName: string
  gradeName: string
  nickname: string
  studiedAt: string
}

export type StudentForStudySearchQuery = {
  bcbtCode?: string
  branchName?: string
  gradeId?: string
  nickname?: string
  studiedAt?: string
}

export type StudentForStudyObject = {
  pagination: Pagination
  responses: StudentForStudyData[]
}

@Component
export default class StudentForStudyApis extends Vue {
  /**
   * テスト情報取得
   */
  protected async getStudy(studyContentId: string): Promise<StudyData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/study_contents/${studyContentId}`)
    return {
      studyName: data.studyName,
      grades: data.grades.map((obj: { id: number; name: string }) => {
        return { value: obj.id, text: obj.name }
      }),
      isScoring: data.isScoring,
    }
  }
  /**
   * 受験者情報取得
   */
  protected async searchStudentForStudy(
    Page: number,
    studyContentId: string,
    studentForStudySearchQuery: StudentForStudySearchQuery
  ): Promise<StudentForStudyObject> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(
      `/v1/academy/study_contents/${studyContentId}/students?page=${Page}`,
      {
        params: studentForStudySearchQuery,
      }
    )
    return data
  }

  /**
   * Excelエクスポート
   */
  protected async export(studyContentId: string): Promise<{ url: string; filename: string }> {
    let res: { data: Blob } = await Vue.prototype.$http.httpWithToken.get(
      `/v1/academy/study_contents/${studyContentId}/export`,
      {
        responseType: 'blob',
        dataType: 'binary',
      }
    )
    return {
      url: URL.createObjectURL(res.data),
      filename: '受験結果.xlsx',
    }
  }
}
